<template>
  <div class="relative grid h-svh w-full grid-cols-1 overflow-hidden lg:grid-cols-[40fr_70fr]">
    <div class="relative flex h-full w-full flex-col items-center justify-center p-8">
      <div class="mb-8 flex items-center gap-2">
        <img
          v-if="whiteLabelRef.logoSmall || whiteLabelRef.logo"
          :src="whiteLabelRef.logoSmall || whiteLabelRef.logo"
          alt="logo"
          class="!h-8 !w-8 shrink-0 rounded-md !object-contain"
        />
        <span class="truncate font-semibold text-foreground">{{ whiteLabelRef.companyName }}</span>
      </div>
      <div class="flex w-full flex-col items-center justify-center gap-4 px-10 text-center">
        <slot name="header"></slot>
      </div>
      <div class="mt-14 w-full px-10">
        <slot name="body"></slot>
      </div>
    </div>
    <div class="hidden h-full w-full bg-primary lg:block">
      <ManIllustrationIcon class="absolute bottom-0 right-0 h-auto w-2/5 translate-y-[5%]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ManIllustrationIcon from '@/features/ui/components/icons/man-illustration-icon.vue'
import useWhiteLabel from '@/hooks/use-white-label.hook'

const { whiteLabelRef } = useWhiteLabel()
</script>
